<template>
  <el-tabs v-model="activeName" @tab-click="handleClick" style="overflow-y: auto" class="inside">
    <el-tab-pane lazy label="凭证与基础信息" name="first">
      <el-row style="margin-top: 30px">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-container class="info-box" :style="{ height: isEditApp ? '275px' : '164px' }">
            <el-header class="info-box-header">
              <el-col :span="16">
                <span class="info-box-title">应用基础信息</span>
              </el-col>
              <el-col :span="8">
                <el-button class="info-box-btn" v-if="!isEditApp && onlyReadState.indexOf(ruleForm.appState) < 0" size="medium" type="primary" @click="switchEdit('app')">修改 </el-button>
                <el-button class="info-box-btn btn-small" v-if="isEditApp" size="medium" type="primary" @click="submitForm('ruleForm')">保存 </el-button>
                <el-button class="info-box-btn btn-small" v-if="isEditApp" size="medium" @click="switchEdit('app')">取消 </el-button>
              </el-col>
            </el-header>
            <el-container>
              <el-aside class="info-box-aside" :style="{ height: isEditApp ? '202px' : '90px' }">
                <el-form-item style="margin-top: 0" v-loading="uploadLoading">
                  <el-row>
                    <el-image v-if="ruleForm.imageUrl" :src="$fileBaseUrl + '62x62/' + ruleForm.imageUrl" :preview-src-list="[$fileBaseUrl + 'x/' + ruleForm.imageUrl]" class="avatar"></el-image>
                    <i v-if="!ruleForm.imageUrl" class="el-icon-picture-outline avatar-uploader-icon"></i>
                  </el-row>
                  <el-row v-if="isEditApp">
                    <el-upload
                      class="avatar-uploader"
                      list-type="picture"
                      action="#"
                      :http-request="uploadFile"
                      accept="image/jpeg,image/png"
                      :on-error="handleAvatarError"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      :on-change="beforeAvatarUpload"
                      :auto-upload="false"
                    >
                      <el-button style="width: 86px; height: 28px; line-height: 0; margin-top: 12px" type="primary">重新上传 </el-button>
                      <div slot="tip" class="el-upload__tip">请上传JPG/PNG格式、240*240px以上、1:1 、1M 以内的无圆角图标</div>
                    </el-upload>
                    <!-- vueCropper 剪裁图片实现-->
                    <el-dialog class="abow_dialog" title="图片剪裁" width="40%" :visible.sync="dialogVisible" append-to-body>
                      <div class="cropper-content">
                        <div class="cropper" style="text-align: center">
                          <vueCropper
                            ref="cropper"
                            :img="option.img"
                            :outputSize="option.size"
                            :outputType="option.outputType"
                            :info="true"
                            :full="option.full"
                            :canMove="option.canMove"
                            :canMoveBox="option.canMoveBox"
                            :original="option.original"
                            :autoCrop="option.autoCrop"
                            :fixed="option.fixed"
                            :fixedNumber="option.fixedNumber"
                            :centerBox="option.centerBox"
                            :infoTrue="option.infoTrue"
                            :fixedBox="option.fixedBox"
                            :autoCropWidth="option.autoCropWidth"
                            :autoCropHeight="option.autoCropHeight"
                            @realTime="realTime"
                            :mode="option.mode"
                          ></vueCropper>
                        </div>
                        <div style="margin-left: 20px">
                          <div class="show-preview" style="width: 150px; height: 150px; overflow: hidden; margin: 5px">
                            <div
                              class="preview"
                              :style="{ width: previews.w + 'px', height: previews.h + 'px', transform: `scale(calc(150 / ${previews.w}),calc(150 / ${previews.h}))`, overflow: 'hidden' }"
                              style="transform-origin: 0 0"
                            >
                              <img :src="previews.url" :style="previews.img" />
                            </div>
                          </div>
                          <div class="show-preview" style="width: 100px; height: 100px; overflow: hidden; margin: 5px">
                            <div
                              class="preview"
                              :style="{ width: previews.w + 'px', height: previews.h + 'px', transform: `scale(calc(100 / ${previews.w}),calc(100 / ${previews.h}))`, overflow: 'hidden' }"
                              style="transform-origin: 0 0"
                            >
                              <img :src="previews.url" :style="previews.img" style="object-fit: fill" />
                            </div>
                          </div>
                          <div class="show-preview" style="width: 50px; height: 50px; overflow: hidden; margin: 5px">
                            <div
                              class="preview"
                              :style="{ width: previews.w + 'px', height: previews.h + 'px', transform: `scale(calc(50 / ${previews.w}),calc(50 / ${previews.h}))`, overflow: 'hidden' }"
                              style="transform-origin: 0 0"
                            >
                              <img :src="previews.url" :style="previews.img" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="margin-top: 20px">
                        <el-button type="primary" @click="changeScale(1)">放大图片</el-button>
                        <el-button type="primary" @click="changeScale(-1)">缩小图片</el-button>
                        <!--<el-button type="primary" @click="$refs.cropper.clearCrop()">重置图片</el-button>-->
                      </div>
                      <div slot="footer" class="dialog-footer">
                        <el-button @click="(dialogVisible = false), (uploadLoading = false)">取 消</el-button>
                        <el-button type="primary" @click="finish">确认</el-button>
                      </div>
                    </el-dialog>
                  </el-row>
                </el-form-item>
              </el-aside>
              <el-container>
                <el-main class="info-box-content" :style="{ height: isEditApp ? '76px' : 'auto' }">
                  <div class="info-box-label md-ellipsis" v-if="!isEditApp">{{ ruleForm.name }}</div>
                  <el-form-item prop="name" v-else style="margin-top: 0">
                    <el-input
                      @blur="cleanBlank('name')"
                      class="info-box-input"
                      size="medium"
                      max="20"
                      min="2"
                      maxlength="20"
                      v-model="ruleForm.name"
                      placeholder="请输入应用名称"
                      clearable
                      show-word-limit
                    ></el-input>
                    <p class="tip">名称可以由中文、数字以及字母组成，长度在2-20个字符可修改</p>
                  </el-form-item>
                </el-main>
                <el-footer class="info-box-footer" :style="{ height: isEditApp ? '124px' : '45px' }">
                  <el-tooltip :content="ruleForm.desc" placement="bottom-start" effect="light" v-if="!isEditApp">
                    <div class="info-box-label md-ellipsis">{{ ruleForm.desc }}</div>
                  </el-tooltip>
                  <el-form-item prop="desc" v-else style="margin-top: 0">
                    <el-input
                      @keydown.native="keydownFunction"
                      @blur="cleanBlank('desc')"
                      class="info-box-textarea"
                      type="textarea"
                      maxlength="100"
                      rows="4"
                      show-word-limit
                      v-model="ruleForm.desc"
                      placeholder="请输入应用描述"
                    ></el-input>
                  </el-form-item>
                </el-footer>
              </el-container>
            </el-container>
          </el-container>
        </el-form>
      </el-row>
      <el-row style="margin-top: 30px">
        <el-container class="info-box" style="height: 164px">
          <el-header class="info-box-header" style="display: flex; justify-content: space-between; align-items: center">
            <span class="info-box-title">应用凭证</span>
            <el-button type="primary" style="width: 130px; height: 36px" @click="confirmIdentity">查看密钥</el-button>
          </el-header>
          <el-container>
            <el-aside class="info-box-aside" style="height: 91px; padding-top: 0">
              <el-container>
                <el-header class="info-box-proof border-bottom">Appld</el-header>
                <el-main class="info-box-proof" style="">AppSecret</el-main>
              </el-container>
            </el-aside>
            <el-container>
              <el-main class="info-box-content" style="height: 46px">
                <el-col :span="8">
                  <div class="info-box-label md-ellipsis">{{ appId }}</div>
                </el-col>
                <el-col :span="4" style="border-left: 1px solid #cdcdcd; border-right: 1px solid #cdcdcd; text-align: center">
                  <div class="info-box-label md-ellipsis">appKey</div>
                </el-col>
                <el-col :span="12">
                  <div class="info-box-label md-ellipsis" style="padding-left: 20px">{{ appKey || "********" }}</div>
                </el-col>
              </el-main>
              <el-footer class="info-box-footer" style="height: 45px">
                <div class="info-box-label md-ellipsis">
                  {{ appSecret || "********" }}<i v-if="appSecret" class="el-icon-document-copy ponter" :data-clipboard-text="appSecret" @click="copySecret"></i>
                </div>
              </el-footer>
            </el-container>
          </el-container>
        </el-container>
      </el-row>
      <div class="remove-row">
        <div class="remove-tip">
          删除操作不可逆，该应用所有信息将被删除，请谨慎操作。
          <div class="remove-btn ponter" @click="openRemoveDialog"><i class="el-icon-warning"></i>删除应用</div>
        </div>
      </div>
      <el-dialog class="abow_dialog" title="删除应用" :visible.sync="dialogRemoveAppVisible" width="30%">
        <el-input class="remove-verify-input" size="medium" v-model.trim="verifyApp" placeholder="请输入应用名称"></el-input>
        <p style="margin: 15px 0; font-size: 14px; color: #666666">所有内容都将无法恢复，请谨慎操作！</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelRemove">取 消</el-button>
          <el-button type="primary" @click="removeApp">确 定</el-button>
        </span>
      </el-dialog>
      <mobile-phone-verification ref="mobilePhoneVerification" :applicationId="applicationId" @showKey="showSecretKey" />
    </el-tab-pane>
    <el-tab-pane lazy label="开发管理" name="second">
      <el-row style="margin-top: 30px">
        <el-container class="info-box" style="height: 210px">
          <el-header class="info-box-header">
            <el-col :span="16">
              <span class="info-box-title">开发管理</span>
            </el-col>
            <el-col :span="8">
              <el-button class="info-box-btn" v-if="onlyReadState.indexOf(ruleForm.appState) < 0" size="medium" type="primary" @click="switchEdit('dev')">修改 </el-button>
            </el-col>
          </el-header>
          <el-container>
            <el-aside class="info-box-aside" style="height: 137px; padding-top: 0">
              <el-container>
                <el-header class="info-box-proof border-bottom">服务器出口IP</el-header>
                <el-main class="info-box-proof border-bottom" style="height: 46px !important">PC端首页地址</el-main>
                <el-footer class="info-box-proof">回调地址</el-footer>
              </el-container>
            </el-aside>
            <el-container>
              <el-main class="info-box-content" style="height: 137px; padding: 0 !important; overflow: hidden">
                <el-container>
                  <el-aside class="info-box-aside" style="height: 137px; padding-top: 0; width: 333px !important">
                    <el-container>
                      <el-header class="info-box-proof border-bottom">
                        <el-tooltip :content="ruleForm.serverExitIP" placement="bottom" effect="light">
                          <div class="info-box-label md-ellipsis">{{ ruleForm.serverExitIP }}</div>
                        </el-tooltip>
                      </el-header>
                      <el-main class="info-box-proof border-bottom" style="height: 46px !important">
                        <el-tooltip :content="ruleForm.pcUrl" placement="bottom" effect="light">
                          <div class="info-box-label md-ellipsis">{{ ruleForm.pcUrl }}</div>
                        </el-tooltip>
                      </el-main>
                      <el-footer class="info-box-proof">
                        <el-tooltip :content="ruleForm.returnUrl" placement="bottom" effect="light">
                          <div class="info-box-label md-ellipsis">{{ ruleForm.returnUrl }}</div>
                        </el-tooltip>
                      </el-footer>
                    </el-container>
                  </el-aside>
                  <el-container>
                    <el-main class="info-box-aside" style="height: 138px; padding: 0 !important; border-right: none">
                      <el-container>
                        <el-header class="info-box-proof border-bottom">
                          <el-col :span="8">
                            <div class="md-ellipsis" style="border-right: 1px solid #cdcdcd">应用首页地址</div>
                          </el-col>
                          <el-col :span="16">
                            <el-tooltip :content="ruleForm.adminUrl" placement="bottom" effect="light">
                              <div class="info-box-label md-ellipsis">{{ ruleForm.adminUrl }}</div>
                            </el-tooltip>
                          </el-col>
                        </el-header>
                        <el-main class="info-box-proof border-bottom" style="height: 46px !important">
                          <el-col :span="8">
                            <div class="md-ellipsis" style="border-right: 1px solid #cdcdcd">H5地址</div>
                          </el-col>
                          <el-col :span="16">
                            <el-tooltip :content="ruleForm.h5Url" placement="bottom" effect="light">
                              <div class="info-box-label md-ellipsis">{{ ruleForm.h5Url }}</div>
                            </el-tooltip>
                          </el-col>
                        </el-main>
                        <el-footer class="info-box-proof"></el-footer>
                      </el-container>
                    </el-main>
                  </el-container>
                </el-container>
              </el-main>
            </el-container>
          </el-container>
        </el-container>
      </el-row>
      <el-dialog class="abow_dialog" title="开发管理" :visible.sync="dialogModifyVisible" :before-close="handleClose" destroy-on-close>
        <el-form class="app-form" :model="urlForm" :rules="rules" ref="urlForm">
          <el-form-item prop="serverExitIP" style="margin-top: 0">
            <div class="label required">服务器出口IP</div>
            <el-input class="limit-input" maxlength="70" show-word-limit size="medium" v-model.trim="urlForm.serverExitIP" placeholder="请输入服务器出口IP" clearable></el-input>
            <p class="tip">IP白名单机制，除您指定的IP外，其他IP不能使用，请谨慎修改！(IP最多4个，多个IP之间请用英文逗号分隔)</p>
          </el-form-item>
          <el-form-item prop="adminUrl">
            <div class="label required">应用首页地址</div>
            <el-input class="limit-input" maxlength="500" show-word-limit size="medium" v-model="urlForm.adminUrl" placeholder="请输入应用首页地址" clearable></el-input>
            <p class="tip">请输入http或https开头的网址链接，如https://www.xxxxx.com</p>
          </el-form-item>
          <el-form-item prop="pcUrl">
            <div class="label required">PC端首页地址</div>
            <el-input class="limit-input" maxlength="500" show-word-limit size="medium" v-model="urlForm.pcUrl" placeholder="请输入PC端首页地址" clearable></el-input>
            <p class="tip">用户可以在PC版工作台上打开这个应用并显示该链接内容。请输入http或https开头的链接，如https://www.xxxxx.com</p>
          </el-form-item>
          <el-form-item prop="h5Url">
            <div class="label">H5地址</div>
            <el-input class="limit-input" maxlength="500" show-word-limit size="medium" v-model="urlForm.h5Url" placeholder="请输入H5地址" clearable></el-input>
            <p class="tip">请输入http或https开头的网址链接，如https://www.xxxxx.com</p>
          </el-form-item>
          <el-form-item prop="returnUrl">
            <div class="label required">回调地址</div>
            <el-input class="limit-input" maxlength="500" show-word-limit size="medium" v-model="urlForm.returnUrl" placeholder="请输入回调地址" clearable></el-input>
            <p class="tip">请输入http或https开头的网址链接，如https://www.xxxxx.com</p>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="switchEdit('dev')">取 消</el-button>
          <el-button type="primary" @click="submitForm('urlForm')">确定</el-button>
        </div>
      </el-dialog>
    </el-tab-pane>
    <el-tab-pane lazy label="权限管理" name="third">
      <el-row style="margin-top: 30px">
        <el-container class="info-box">
          <el-header class="info-box-header" style="border-bottom: none">
            <el-col :span="16">
              <span class="info-box-title">已添加接口权限</span>
            </el-col>
            <el-col :span="8">
              <el-button class="info-box-btn" v-if="onlyReadState.indexOf(ruleForm.appState) < 0" size="medium" type="primary" @click="selectAuth">添加接口权限 </el-button>
            </el-col>
          </el-header>
          <el-main style="padding: 0">
            <new-table :data="appRouteList" :columns="columns" :pages="false"></new-table>
          </el-main>
        </el-container>
      </el-row>
    </el-tab-pane>
    <el-dialog class="abow_dialog" title="添加接口权限" :visible.sync="dialogPortAuthVisible" :before-close="handleClose" destroy-on-close width="52%">
      <el-container class="container">
        <el-aside width="47%" class="aside">
          <div class="header">可添加：</div>
          <div class="tree-container">
            <el-tree class="tree" node-key="id" default-expand-all check-strictly :props="defaultProps" :data="routeData" :expand-on-click-node="true" @check-change="handleCheckChange" ref="tree1">
              <div class="custom-tree-node" slot-scope="{ node, data }" :title="node.label">
                <div class="md-ellipsis" style="width: 90%; display: inline-block">{{ node.label }}</div>
                <span style="float: right" v-if="!data.routePublicList || data.routePublicList.length == 0">
                  <el-button type="text" @click="() => check(node, data)" v-if="portAuthIds.indexOf(data.routePublicId) < 0">
                    <i class="el-icon-circle-plus-outline" style="font-size: 16px"></i>
                  </el-button>
                </span>
              </div>
            </el-tree>
          </div>
        </el-aside>
        <el-main style="padding: 0 !important; margin-left: 25px">
          <div class="header">已添加：</div>
          <div class="tree-container">
            <el-tree
              class="tree"
              node-key="id"
              default-expand-all
              check-strictly
              :props="defaultProps"
              :data="portAuthArray"
              :expand-on-click-node="true"
              @check-change="handleCheckChange"
              ref="tree2"
            >
              <div class="custom-tree-node" slot-scope="{ node, data }" :title="node.label">
                <div class="md-ellipsis" style="width: 90%; display: inline-block" :style="{ color: data.isEnabled == 1 || !data.routePublicId ? '#606266' : '#BFBFBF' }">
                  {{ data.isEnabled == 0 ? "（已禁用）" + node.label : node.label }}
                </div>
                <span style="float: right" v-if="!data.routePublicList || data.routePublicList.length == 0">
                  <el-button type="text" @click.stop="unCheck(node, data)">
                    <i class="el-icon-remove-outline color-red" style="font-size: 16px"></i>
                  </el-button>
                </span>
              </div>
            </el-tree>
          </div>
        </el-main>
      </el-container>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPortAuthVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPortAuth()">确认</el-button>
      </div>
    </el-dialog>
    <!-- <el-tab-pane lazy label="事件订阅" name="fifth">
      <inside-event :ruleForm="ruleForm"></inside-event>
    </el-tab-pane> -->
    <el-tab-pane lazy label="版本管理及上线" name="fourth">
      <el-row style="margin-top: 30px">
        <el-col :span="24">
          <div class="title-logo"></div>
          <div class="title">可使用范围</div>
        </el-col>
      </el-row>
      <el-row class="margin-top-sm">
        <el-col>
          <span class="text-df">添加可使用人员，用于开发过程中体验与测试（开发版本最多20人可见）</span>
          <el-button :disabled="onlyReadState.indexOf(ruleForm.appState) > 0" style="width: 109px; margin-left: 24px" size="medium" type="primary" @click="selectOrg()">添加 </el-button>
        </el-col>
        <el-col>
          <div class="tag-group">
            <el-tag class="tag-item" v-for="user in authUsers" :key="user.realName" size="medium" :closable="onlyReadState.indexOf(ruleForm.appState) < 0" effect="plain" @close="removeUser(user)">
              {{ user.relationType == 1 ? user.name : user.realName }}
            </el-tag>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-button class="margin-tb-sm" size="medium" type="primary" @click="saveAppSetting" :disabled="onlyReadState.indexOf(ruleForm.appState) > 0">保存修改 </el-button>
      </el-row>
      <el-row class="margin-top-sm">
        <el-col :span="24">
          <div class="title-logo"></div>
          <div class="title">应用发布</div>
        </el-col>
      </el-row>
      <!-- 0.默认状态 1待审核 2 审合通过(上线) 3审核拒绝 4 客户下架 5平台下架 6 删除 -->
      <el-row v-if="ruleForm.appState == 0 || ruleForm.appState == 3 || ruleForm.appState == 4 || ruleForm.appState == 5">
        <el-col class="delete-tip text-df">发布后，该应用将会出现在企业的平台上，企业组织内部的用户将会看到该应用。</el-col>
        <el-col>
          <el-button size="medium" type="primary" @click="releaseApp(2)">应用发布</el-button>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.appState == 2">
        <el-col class="delete-tip text-df">应用已审核上线，您可以下架您的应用。</el-col>
        <el-col>
          <el-button size="medium" type="danger" @click="releaseApp(4)">下架</el-button>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.appState == 1">
        <el-col class="delete-tip text-df">应用正在审核。</el-col>
        <el-col>
          <el-button size="medium" type="danger" @click="releaseApp(0)">撤回</el-button>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.appState == 6">
        <el-col class="delete-tip text-df"><span class="color-red">应用已被删除。</span></el-col>
      </el-row>
    </el-tab-pane>
    <select-user :user-visible="selectUserVisible" v-if="selectUserVisible" @close="selectDilogClose" @submitUser="selectCallback" :selectOu="authUsers"></select-user>
  </el-tabs>
</template>
<script>
import "@/assets/css/tree.scss";
import { Evens } from "@/utils";
import axios from "axios";
import newTable from "../../components/new-table";
import mobilePhoneVerification from "../Third/comp/mobile-phone-verification";
import InsideEvent from "./inside-event";
export default {
  components: {
    newTable,
    mobilePhoneVerification,
    InsideEvent,
  },
  data() {
    let validateIP = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写服务器出口IP"));
      } else {
        let arr = value.split(",");
        let reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        let res = arr && arr.some((i) => !reg.test(i));
        if (res) {
          callback(new Error("请填写正确的服务器出口IP"));
        } else if (arr.length > 4) {
          callback(new Error("IP最多4个"));
        } else {
          callback();
        }
      }
    };
    return {
      columns: [
        { label: "类型", prop: "routeGroupName" },
        { label: "权限", prop: "routeName" },
        { label: "描述", prop: "routeDescription" },
        {
          label: "操作",
          width: "100",
          render: (h, scope) => {
            return (
              <div>
                <el-button
                  disabled={scope.row.default || this.onlyReadState.indexOf(this.ruleForm.appState) > 0 || this.ruleForm.appState == 2 || this.ruleForm.appState == 1}
                  type="text"
                  size="small"
                  on={{
                    click: () => {
                      this.removeAuth(scope.row);
                    },
                  }}
                >
                  移除
                </el-button>
              </div>
            );
          },
        },
      ],
      applicationId: 0,
      appId: 0,
      appKey: "",
      appSecret: "",
      activeName: "first", //默认显示哪个tab页
      selectUserVisible: false,
      dialogPortAuthVisible: false,
      dialogRemoveAppVisible: false, //删除app弹窗
      verifyApp: "",
      isEditApp: false, //app基本信息是否处于编辑状态
      isEditDev: false, //app开发管理信息是否处于编辑状态
      dialogModifyVisible: false, //开发管理修改弹窗
      uploadLoading: false,
      tmp: {},
      tagInputVisible: false, //标签是否处于编辑状态
      tagInputValue: "",
      onlyReadState: [1, 2, 6], //不能进行修改的app状态
      ruleForm: {
        name: "",
        desc: "",
        logo: null,
        imageUrl: "", //图片地址
        serverExitIP: "", //服务器出口IP
        pcUrl: "", //pc首页地址
        h5Url: "", //h5地址
        adminUrl: "", //应用首页地址
        returnUrl: "", //url回调地址
        appState: 0,
        tags: [],
      },
      //可使用范围权限人员
      authUsers: [],
      //校验规则
      rules: {
        name: [
          { required: true, message: "请输入应用名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" },
        ],
        desc: [{ required: true, message: "请填写应用描述", trigger: "blur" }],
        serverExitIP: [{ trigger: "blur", validator: validateIP }],
        pcUrl: [{ trigger: "blur", message: "请填写PC端首页地址", required: true }],
        returnUrl: [{ trigger: "blur", message: "请填写回调地址", required: true }],
        adminUrl: [{ trigger: "blur", message: "请填写应用首页地址", required: true }],
      },
      radioAuth: "1",
      radioUse: "1",
      // 公开的路由列表
      routeData: [],
      defaultProps: {
        children: "routePublicList",
        label: "treeName",
      },
      // 已添加的路由接口
      portAuthArray: [],
      portAuthIds: [],
      appRouteList: [],
      urlForm: {
        serverExitIP: "",
        adminUrl: "",
        pcUrl: "",
        h5Url: "",
        returnUrl: "",
      },
      // 裁剪组件的基础配置option
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "png", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        mode: "cover",
      },
      picsList: [], //页面显示的数组
      previews: {},
    };
  },
  created() {
    this.applicationId = this.$route.query.id;
    this.getAppInfoById();
    this.getAppRoute();
  },

  methods: {
    keydownFunction(event) {
      if (event.keyCode === 13) {
        event.preventDefault(); // 阻止浏览器默认换行操作
        return false;
      }
    },
    copySecret() {
      let oInput = document.createElement("input");
      oInput.value = this.appSecret;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy");
      this.$message.success("已复制到剪贴板");
      oInput.remove();
    },
    //tab切换事件
    handleClick(tab, event) {
      switch (tab) {
        case "first":
          this.getAppInfoById();
          break;
        case "second":
          this.getAppConfigById();
          break;
        case "third":
          this.getAppRouteTree();
          break;
        case "fourth":
          this.getAppTestList();

          break;
        default:
          break;
      }
    },
    cleanBlank(type) {
      if (type == "name") {
        this.ruleForm.name = this.ruleForm.name.replace(/\s*/g, "");
      } else {
        this.ruleForm.desc = this.ruleForm.desc.replace(/\s*/g, "");
      }
    },
    //切换修改和查看
    switchEdit(type) {
      if (type == "app") {
        if (!this.isEditApp) {
          //临时保存数据
          this.tmp = JSON.parse(JSON.stringify(this.ruleForm));
        } else {
          this.tmp && (this.ruleForm = JSON.parse(JSON.stringify(this.tmp)));
          this.tmp = {};
        }
        this.isEditApp = !this.isEditApp;
      } else {
        if (!this.isEditDev) {
          for (var key in this.urlForm) {
            this.urlForm[key] = this.ruleForm[key];
          }
          //临时保存数据
          this.tmp = JSON.parse(JSON.stringify(this.ruleForm));
        } else {
          this.tmp && (this.ruleForm = JSON.parse(JSON.stringify(this.tmp)));
          this.tmp = {};
        }
        this.isEditDev = !this.isEditDev;
        this.dialogModifyVisible = this.isEditDev;
      }
    },
    //选择节点 返回值为 该节点所对应的对象 data、节点本身是否被选中 checked、节点的子树中是否有被选中的节点 indeterminate
    handleCheckChange(data, checked) {},
    // 删除某个标签
    delTag(tag) {
      this.ruleForm.tags.splice(this.ruleForm.tags.indexOf(tag), 1);
    },
    // 显示新增标签input
    showInput() {
      this.tagInputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 保存标签
    tagInputConfirm() {
      let tagInputValue = this.tagInputValue;
      if (tagInputValue.length > 6) {
        this.$message.warning("标签不能超过6个字");
        this.$refs.saveTagInput.$refs.input.focus();
        return;
      }
      if (tagInputValue) {
        this.ruleForm.tags.push(tagInputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = "";
    },
    handleClose(done) {
      this.isEditDev = !this.isEditDev;
      done();
    },
    // 获取应用基础信息
    getAppInfoById() {
      let url = `/Opencloud/Application/ApplicationById?id=${this.applicationId}`;
      this.axios.get(url).then((data) => {
        this.ruleForm.name = data.appName;
        this.ruleForm.desc = data.appDescription;
        this.ruleForm.appState = data.appState;
        this.ruleForm.serverExitIP = data.serverExitIP;
        this.ruleForm.returnUrl = data.returnUrl;
        this.ruleForm.h5Url = data.h5Url;
        this.ruleForm.pcUrl = data.pcUrl;
        this.ruleForm.adminUrl = data.adminUrl;
        this.appId = data.appId;
        // this.appKey = data.appKey;
        // this.appSecret = data.appSecret;
        this.ruleForm.tags = data.appTag.split(",");
        this.ruleForm.imageUrl = data.appLogo.replace(/\\/g, "/");
      });
    },
    // 获取app应用凭证配置
    getAppConfigById() {
      let url = `/Opencloud/Application/AppConfigByApplicationId?applicationId=${this.applicationId}`;
      this.axios.get(url).then((data) => {
        this.ruleForm.serverExitIP = data.serverExitIP;
        this.ruleForm.returnUrl = data.returnUrl;
        this.ruleForm.h5Url = data.h5Url;
        this.ruleForm.pcUrl = data.pcUrl;
        this.ruleForm.adminUrl = data.adminUrl;
      });
    },
    check(node, data) {
      var parent = JSON.parse(JSON.stringify(node.parent.data));

      let hasParentNode = false;
      if (this.portAuthIds.indexOf(data.routePublicId) > -1) {
        return;
      }
      this.portAuthIds.push(data.routePublicId);
      this.portAuthArray.forEach((item) => {
        if (item.routeGroupId == parent.routeGroupId) {
          item.routePublicList.push(data);
          hasParentNode = true;
        }
      });
      if (!hasParentNode) {
        parent.routePublicList = [data];
        this.portAuthArray.push(parent);
      }
    },

    unCheck(node, data) {
      let idx = this.portAuthIds.indexOf(data.routePublicId);
      var parent = JSON.parse(JSON.stringify(node.parent.data));
      this.portAuthIds.splice(idx, 1);
      this.portAuthArray.forEach((item, index) => {
        if (item.routePublicId == parent.routePublicId) {
          item.routePublicList &&
            item.routePublicList.forEach((e, i) => {
              if (e.routePublicId == data.routePublicId) {
                item.routePublicList.splice(i, 1);
                if (item.routePublicList.length == 0) {
                  this.portAuthArray.splice(index, 1);
                }
              }
            });
        }
      });
    },

    //获取已选择的应用路由树
    getAppRouteTree() {
      let url = "/Opencloud/Application/ApplicationRouteTree?applicationId=" + this.applicationId;
      this.axios.get(url).then((res) => {
        this.portAuthArray = res;
        this.portAuthIds = [];
        this.portAuthArray.forEach((item) => {
          item.routePublicList.forEach((t) => {
            this.portAuthIds.push(t.routePublicId);
          });
        });
      });
    },

    //保存接口权限
    submitPortAuth() {
      let url = "/Opencloud/Application/SaveApplicationRoute";
      let routeList = [];
      this.portAuthArray.forEach((item) => {
        routeList = routeList.concat(item.routePublicList);
      });

      let postdata = {
        applicationId: this.applicationId,
        appId: this.appId,
        routeList: routeList,
      };
      this.axios.post(url, postdata).then((res) => {
        this.dialogPortAuthVisible = false;
        this.getAppRoute();
        this.getAppRouteTree();
      });
    },

    //保存修改
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "ruleForm") {
            if (this.ruleForm.name.trim() == "") {
              this.$message.warning("请输入应用名称");
              return;
            }
            if (this.ruleForm.desc.trim() == "") {
              this.$message.warning("请输入应用描述");
              return;
            }
            let postdata = {
              id: this.applicationId,
              appName: this.ruleForm.name,
              appDescription: this.ruleForm.desc,
              appLogo: this.ruleForm.imageUrl,
              appLogoFile: this.ruleForm.logo,
              appTypeId: 1,
              appTag: this.ruleForm.tags.join(","),
            };
            this.axios.post("/Opencloud/Application/ModifyApplication", postdata).then((res) => {
              if (res == true) {
                this.$message.success("修改应用成功");
                this.getAppInfoById();
                this.isEditApp = false;
                Evens.emit("modify-app", postdata);
              } else {
                this.$message.error("修改应用失败");
              }
            });
          } else {
            if (this.urlForm.serverExitIP.trim() == "") {
              this.$message.warning("请输入服务器出口IP");
              return;
            }
            if (this.urlForm.adminUrl.trim() == "") {
              this.$message.warning("请输入应用首页地址");
              return;
            }
            if (this.urlForm.returnUrl.trim() == "") {
              this.$message.warning("请输入回调地址");
              return;
            }
            let postdata = {
              applicationId: this.applicationId,
              pcUrl: this.urlForm.pcUrl,
              returnUrl: this.urlForm.returnUrl,
              serverExitIP: this.urlForm.serverExitIP,
              h5Url: this.urlForm.h5Url,
              adminUrl: this.urlForm.adminUrl,
            };
            this.axios.post("/Opencloud/Application/ModifyApplicationConfig", postdata).then((res) => {
              if (res == true) {
                this.$message.success("配置成功");
                this.getAppConfigById();
                this.isEditDev = false;
                this.dialogModifyVisible = false;
              } else {
                this.$message.error("配置失败");
              }
            });
          }
        } else {
          this.$message({
            type: "warning",
            message: "请按照提示正确输入信息后再保存",
          });
          return false;
        }
      });
    },
    //放大/缩小
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    // 实时预览函数
    realTime(data) {
      this.previews = data;
    },
    beforeAvatarUpload(file) {
      let types = ["image/jpeg", "image/jpg", "image/png"];
      const isImage = types.includes(file.raw.type);
      if (!isImage) {
        this.uploadLoading = false;
        this.$message.error("上传图片只能是 JPG、JPEG、PNG、GIF 格式!");
        return false;
      }
      const isLt = file.size / 1024 <= 1024;
      if (!isLt) {
        this.uploadLoading = false;
        this.$message.warning("上传logo大小小于等于1M");
        return false;
      }
      this.uploadLoading = true;
      // 获取上传图片的本地URL，用于上传前的本地预览
      var URL = null;
      if (window.createObjectURL != undefined) {
        // basic
        URL = window.createObjectURL(file.raw);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        URL = window.URL.createObjectURL(file.raw);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        URL = window.webkitURL.createObjectURL(file.raw);
      }
      file.url = URL;
      this.fileinfo = file;
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = file.url;
        this.dialogVisible = true;
      });
    },
    /*//Logo上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const limit = file.size / 1024 < 1024;
      if (!limit) {
        this.$message.error('上传图片大小不能超过 1M!');
        return false;

      }
      let sure = (isJPG || isPNG) && limit;
      if (sure) {
        this.uploadLoading = true;
      } else {
        this.uploadLoading = false;
        this.$message.warning("只能上传图片!");

      }
      return sure;
    },*/
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        this.uploadLoading = true;
        const formdata = new FormData();
        formdata.append("file", data, this.fileinfo.name);
        let fileExt1 = this.fileinfo.name.substring(this.fileinfo.name.lastIndexOf("."));
        let fileExt2 = this.fileinfo.name.substring(this.fileinfo.name.lastIndexOf(".") + 1);
        let url = "Opencloud/File/MinioUploadURL?fileExt=" + fileExt2 + "&funcName=AppLogo";
        this.$axios.get(url).then((message) => {
          if (message) {
            this.$uaxios.put(message.uploadPath, data).then(
              (res) => {
                if (res.status === 200) {
                  res.filePath = message.filePath;
                  res.fileExt = fileExt1;
                  this.dialogVisible = false;
                  this.handleAvatarSuccess(res);
                } else {
                  this.uploadLoading = false;
                  this.$message.error("上传失败！");
                }
              },
              (err) => {
                this.uploadLoading = false;
                this.$message.error("上传失败！");
              }
            );
          }
        });
      });
    },
    //自定义上传方法
    async uploadFile(event) {
      let fileExt1 = event.file.name.substring(event.file.name.lastIndexOf("."));
      let fileExt2 = event.file.name.substring(event.file.name.lastIndexOf(".") + 1);
      let urlData = await this.$axios.get("Opencloud/File/MinioUploadURL?fileExt=" + fileExt2 + "&funcName=AppLogo");
      let fileData = await axios.put(urlData.uploadPath, event.file, { headers: { "Content-Type": "" } });
      if (fileData.status == 200) {
        return { data: { filePath: urlData.filePath, fileName: event.file.name, fileExt: fileExt1 } };
      } else {
        throw new Error("上传失败");
      }
    },
    // 上传应用logo回调
    handleAvatarSuccess(res) {
      this.uploadLoading = false;
      this.ruleForm.logo = {
        fileExt: res.fileExt,
        filePath: res.filePath,
      };
      this.ruleForm.imageUrl = this.ruleForm.logo.filePath.replace(/\\/g, "/");
    },
    handleAvatarError() {
      this.uploadLoading = false;
      this.$message.error("上传应用Logo失败");
    },
    openRemoveDialog() {
      if (this.ruleForm.appState == 2) {
        this.$message.warning("请下架应用后再执行删除应用操作");
        return;
      }
      this.dialogRemoveAppVisible = true;
    },
    //删除应用
    removeApp() {
      if (this.verifyApp.trim() == "") {
        this.$message.error("请输入应用名称");
        return;
      }
      if (this.verifyApp !== this.ruleForm.name) {
        this.$message.error("请正确输入要删除的应用名称");
        return;
      }
      this.$confirm("该应用所有信息将被删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = "/Opencloud/Application/ApplicationById?applicationId=" + this.applicationId;
          this.axios.delete(url).then((res) => {
            this.$message.success("删除应用成功");
            this.dialogRemoveAppVisible = true;
            Evens.emit("del-app", this.applicationId);
            this.$router.back();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    cancelRemove() {
      this.verifyApp = "";
      this.dialogRemoveAppVisible = false;
    },
    //选择行业
    selectIndstry() {},
    //选择人员部门
    selectOrg() {
      this.selectUserVisible = true;
      // this.$nextTick(()=>{
      // 	this.$refs.selectOrgUser.init();
      // })
    },
    //选择人员部门回调
    selectCallback(data) {
      this.authUsers = data;
      this.selectUserVisible = false;
    },
    selectDilogClose() {
      this.selectUserVisible = false;
    },
    removeUser(item) {
      this.authUsers.splice(this.authUsers.indexOf(item), 1);
    },
    //保存使用范围修改
    saveAppSetting() {
      if (this.authUsers.length > 20) {
        this.$message.warning("开发版本最多20人可见");
        return;
      }
      let postData = {
        applicationId: this.applicationId,
        appId: this.appId,
        relationList: this.authUsers.map((item) => {
          return {
            relationId: item.id,
            relationType: item.relationType,
          };
        }),
      };
      let url = "/Opencloud/Application/SaveAppAuthRelationTest";
      this.axios.post(url, postData).then((res) => {
        if (res) {
          this.$message.success("保存测试人员成功");
          this.getAppTestList();
        } else {
          this.$message.error("保存测试人员失败");
        }
      });
    },
    // 获取已保存的测试人员
    getAppTestList() {
      let url = "/Opencloud/Application/AppAuthRelationTestList?" + "applicationId=" + this.applicationId;
      this.axios.get(url).then((res) => {
        this.authUsers = res.map((item) => {
          return {
            id: item.relationId,
            relationType: item.relationType,
            compId: item.compId,
            name: item.relationName,
            realName: item.relationName,
          };
        });
      });
    },
    // 获取应用接口权限
    getAppRoute() {
      let url = "/Opencloud/Application/ApplicationRoutePageList?pageIndex=1&pageSize=999&applicationId=" + this.applicationId;
      this.axios.get(url).then((res) => {
        if (res) {
          this.appRouteList = res.data;
        }
      });
    },
    //添加权限事件
    selectAuth() {
      this.getAppRouteTree();
      this.getRoutePublicList();
      this.dialogPortAuthVisible = true;
    },

    //移除权限事件
    removeAuth(data) {
      if (this.ruleForm.appState == 2 || this.ruleForm.appState == 1) {
        this.$message.warning("请下架应用后再执行删除操作");
        return;
      }
      this.$confirm("该权限将被移除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = "/Opencloud/Application/AppRouteById?id=" + data.id;
          this.axios.delete(url).then((res) => {
            this.$message.success("移除成功");
            this.getAppRoute();
          });
        })
        .catch(() => {
          this.$message.info("已取消移除");
        });
    },

    // 获取公开接口路由权限
    getRoutePublicList() {
      let url = "/Opencloud/Route/CompGetRoutePublicTreeList";
      this.axios.get(url).then((res) => {
        if (res) {
          this.routeData = res;
        }
      });
    },

    //radioAuth切换
    changeRadioAuth() {},
    //radioUser切换
    changeRadioUse() {},
    //修改应用状态
    releaseApp(state) {
      // 0.默认状态 1待审核 2 审合通过(上线) 3审核拒绝 4 客户下架 5平台下架 6 删除
      if ((state == 1 || state == 2) && (!this.ruleForm.serverExitIP || !this.ruleForm.h5Url || !this.ruleForm.returnUrl)) {
        this.$message.error("请完善开发管理信息");
        return;
      }
      let handle;
      switch (state) {
        case 0:
          handle = "撤回应用";
          break;
        case 1:
          handle = "提交审核";
          break;
        case 2:
          handle = "发布应用";
          break;
        case 4:
          handle = "下架应用";
          break;
        default:
          break;
      }
      this.$confirm("是否" + handle, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = "/Opencloud/Application/ModifyApplicationState";
          let postdata = {
            id: this.applicationId,
            appState: state,
            auditNotes: "", //审核备注
          };
          this.axios.post(url, postdata).then((res) => {
            if (res) {
              this.$message.success(handle + "成功");
              this.ruleForm.appState = state;
              Evens.emit("modify-app", postdata);
              if (state == 2) {
                this.authUsers.length = 0;
              }
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },

    //查看密钥
    confirmIdentity() {
      this.$refs.mobilePhoneVerification.open();
    },
    showSecretKey(info) {
      this.appKey = info.appKey;
      this.appSecret = info.appSecret;
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-tree-node {
  height: 30px;
  line-height: 30px;
  flex: 1;
}

// 截图
.cropper-content {
  display: flex;

  .cropper {
    width: 70%;
  }

  .cropper3 {
    width: 30%;
    margin-left: 50px;
  }
}

.border-bottom {
  border-bottom: 1px solid #cdcdcd;
}

.inside {
  ::v-deep .el-table__body-wrapper {
    height: auto !important;
  }

  .el-icon-document-copy {
    color: #1890ffff;
    margin-left: 12px;
    font-size: 17px;
  }

  .remove-row {
    width: 936px;
    margin-top: 23px;
    text-align: right;

    .remove-tip {
      color: #999999ff;
      font-size: 10px;
      display: inline-flex;

      .remove-btn {
        color: #d91515ff;

        .el-icon-warning {
          padding: 0 16px;
        }
      }
    }
  }

  .info-box {
    width: 936px;
    border: 1px solid #cdcdcd;
    border-radius: 6px;

    .info-box-header {
      height: 72px !important;
      border-bottom: 1px solid #cdcdcd;

      .info-box-title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #666666;
        line-height: 72px;
      }

      .info-box-btn {
        float: right;
        margin-top: 18px;
        width: 130px;
      }

      .btn-small {
        margin-right: 8px;
        width: 80px;
      }
    }

    .info-box-aside {
      width: 133px !important;
      text-align: center;
      border-right: 1px solid #cdcdcd;
      padding-top: 14px;

      .avatar {
        height: 62px;
        width: 62px;
        border-radius: 15px;
      }

      .el-upload__tip {
        font-size: 11px;
        color: #999999;
        line-height: 15px;
      }

      .info-box-proof {
        height: 45px !important;
        padding: 0;
        color: #666666ff;
        font-size: 14px;
        line-height: 45px;
        width: 100%;
      }
    }

    .info-box-content {
      padding: 0 20px !important;
      border-bottom: 1px solid #cdcdcd;

      .appName-row {
        ::v-deep .el-form-item__error {
          margin-left: 524px;
          margin-top: -46px;
        }
      }

      .info-box-input {
        margin-top: 8px;
        width: 514px;
      }

      .tip {
        font-size: 11px;
        color: #999999;
      }
    }

    .info-box-footer {
      height: 45px;

      .info-box-textarea {
        margin-top: 12px;

        ::v-deep textarea {
          max-height: 100px;
        }
      }
    }

    .info-box-label {
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333333ff;
      font-size: 14px;
      line-height: 45px;
    }
  }

  .el-tabs__item {
    padding: 0 50px;
  }

  .tag-group {
    .tag-item {
      padding: 0 10px;
      margin-left: 10px;
      margin-top: 10px;
    }
  }

  .title {
    font-weight: 400;
    color: #333333ff;
    font-size: 18px;
    width: 200px;
    /*border-bottom: 1px solid rgba(233, 233, 233, 1)*/
    .buttons {
      text-align: end;
      height: 21px;
    }
  }

  .title-logo {
    background-color: #1b9aee;
    border-radius: 1px;
    margin-right: 20px;
    width: 4px;
    height: 22px;
    float: left;
  }

  .delete-tip {
    padding: 15px 0;
  }
}

.header div {
  width: 50%;
  font-size: 16px;
  display: inline-table;
  margin-bottom: 4px;
}

.container {
  height: 480px;
  border: none;

  .aside {
    .tree-container {
      border: 1px solid #d7d7d7;
      border-radius: 12px;
      overflow: hidden;

      .el-tree {
        border-radius: 12px;
        height: 400px;
        overflow: auto;
        padding: 10px;
      }
    }
  }

  .header {
    height: 40px;
    background: #f1f1f1ff;
    line-height: 40px;
    color: #333333ff;
    font-size: 16px;
    border-radius: 5px;
    padding-left: 10px;
    margin-bottom: 15px;
  }

  .el-main {
    .tree-container {
      border: 1px solid #d7d7d7;
      border-radius: 12px;
      overflow: hidden;

      .el-tree {
        border-radius: 12px;
        height: 400px;
        overflow: auto;
        padding: 10px;
      }
    }
  }
}

.el-form-item {
  margin-bottom: 0 !important;
  height: 100% !important;
  margin-top: 14px;
}

.limit-input {
  ::v-deep .el-input__inner {
    padding-right: 90px !important;
  }
}

.app-form {
  .label {
    color: #000000ff;
    width: 100%;
    font-size: 14px;
    float: left;
  }

  .tip {
    color: #999999ff;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 17px;
    margin-top: 8px;
  }

  .logo-tip {
    margin-top: 140px;
    margin-left: 108px;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
}

.text-df {
  color: #666666ff;
  font-size: 14px;
}

.remove-verify-input {
  ::v-deep .el-input__inner {
    border: none;
    border-radius: 0;
    border-bottom: 2px solid #2e79e9ff;
  }
}

::v-deep .el-tree-node {
  position: relative;
}

::v-deep .el-tree-node__expand-icon {
  z-index: 10;

  &::before {
    background: #fff;
  }
}

::v-deep .el-tree-node:after {
  content: "";
  left: 13px;
  position: absolute;
  right: auto;
  border-width: 1px;
  border-top: 1px solid #ccc;
  height: 20px;
  top: 12px;
  width: 10px;
  z-index: 0;
}

::v-deep .el-tree-node {
  &:before {
    content: "";
    left: 13px;
    position: absolute;
    right: auto;
    border-width: 1px;
    border-left: 1px solid #ccc;
    bottom: 0;
    height: 38px;
    top: -26px;
    width: 1px;
    z-index: 1;
  }

  &:first-child::before {
    display: none;
  }

  &:last-child::before {
    display: block;
  }
}
</style>
